import React, { useState } from 'react';
import { pluralise } from '@lib/utils';
import PropTypes from 'prop-types';
import ColourTabs from './colourTabs';
import ColourVehicleCard from './colourVehicleCard';

const ColourTabsContainer = ({
  colourGroups,
  placeholderImg,
  title,
  viewAllUrl,
}) => {
  const groups = JSON.parse(colourGroups);
  const [activeTab, setActiveTab] = useState('All Colours');

  const renderColours = () => {
    return groups[activeTab].vehicles.map((vehicle) => {
      return (
        <ColourVehicleCard
          key={vehicle.stockReference}
          placeholderImg={placeholderImg}
          vehicle={vehicle}
        />
      );
    });
  };

  return (
    <div className="sm:ch-ba--1 ch-bc--grey-3 ch-bg--white ch-mh--n2 sm:ch-mh--0 ch-mb--4">
      <ColourTabs
        activeTab={activeTab}
        groups={groups}
        setActiveTab={setActiveTab}
      />

      {renderColours()}

      {groups[activeTab].count > 4 && (
        <div className="ch-display--flex ch-justify-content--center ch-ma--2">
          <a
            className="ch-btn ch-fs--2 sl:ch-fs--3 md:ch-fs--2 lg:ch-fs--3 ch-ph--3 ch-mv--1 view-all-button"
            data-gtm-track="interaction"
            data-gtm-track-action="Online showroom"
            data-gtm-track-label="Clicked view all via tabs"
            href={
              activeTab === 'All Colours'
                ? viewAllUrl
                : `${viewAllUrl}&colour%5B%5D=${activeTab}`
            }
            rel="nofollow"
            type="button"
          >
            View {groups[activeTab].count > 1 ? 'all ' : ''}
            {groups[activeTab].count}
            {activeTab === 'All Colours' ? ' ' : ` ${activeTab.toLowerCase()} `}
            pre-reg {title} {`${pluralise(groups[activeTab].count, 'car')}`}
          </a>
        </div>
      )}
    </div>
  );
};

export default ColourTabsContainer;

ColourTabsContainer.propTypes = {
  colourGroups: PropTypes.string,
  placeholderImg: PropTypes.string,
  title: PropTypes.string,
  viewAllUrl: PropTypes.string,
};
